import React from 'react';
import { FDFacetLogo } from '@facet-wealth/design';
import { useDashboardPath } from 'Components/ClientApp/CombinedApp/Navigation/useDashboardPath';
import { NavButton } from '../NavButton';

export const LogoNavButton = () => {
  const { dashboardPath } = useDashboardPath();
  return <NavButton value="logo" to={dashboardPath} label={<FDFacetLogo size="md" />} />;
};
